<template>
  <div>
    <v-card class="my-7" flat>
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-icon color="black">mdi-eye</v-icon>
          <h1 class="ml-2 my-0">Impressions</h1>
        </div>
        <div><span class="count"> 789 </span></div>
      </div>
      <div class="mx-4">
        <LineChartGenerator
          :chart-options="chartOptions"
          :chart-data="chartData"
          :chart-id="chartId"
          :dataset-id-key="datasetIdKey"
          :plugins="plugins"
          :css-classes="cssClasses"
          :styles="styles"
          :width="width"
          :height="height"
        />
      </div>
    </v-card>
    <v-card class="my-7" flat>
      <div class="d-flex justify-space-between">
        <div class="d-flex align-center">
          <v-card flat
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              width="21"
              height="21"
              viewBox="0 0 21 21"
              fill="none"
            >
              <path
                d="M9.71 15.99C6.53 15.84 4 13.22 4 10C4 6.69 6.69 4 10 4C13.22 4 15.84 6.53 15.99 9.71L13.89 9.08C13.48 7.31 11.89 6 10 6C7.79 6 6 7.79 6 10C6 11.89 7.31 13.48 9.08 13.89L9.71 15.99ZM20 10C20 10.3 19.99 10.6 19.96 10.9L17.99 10.31C18 10.21 18 10.1 18 10C18 5.58 14.42 2 10 2C5.58 2 2 5.58 2 10C2 14.42 5.58 18 10 18C10.1 18 10.21 18 10.31 17.99L10.9 19.96C10.6 19.99 10.3 20 10 20C4.48 20 0 15.52 0 10C0 4.48 4.48 0 10 0C15.52 0 20 4.48 20 10ZM16.23 14.26L20 13L10 10L13 20L14.26 16.23L18.53 20.5L20.51 18.52L16.23 14.26Z"
                fill="#222222"
              /></svg
          ></v-card>
          <h1 class="ml-2 my-0">Clicks</h1>
        </div>
        <div><span class="count"> 789 </span></div>
      </div>
      <div class="mx-4">
        <LineChartGenerator
          :chart-options="chartOptions"
          :chart-data="chartData1"
          :chart-id="chartId"
          :dataset-id-key="datasetIdKey"
          :plugins="plugins"
          :css-classes="cssClasses"
          :styles="styles"
          :width="width"
          :height="height"
        />
      </div>
    </v-card>
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);
export default {
  name: "AnalyticsComponent",
  components: {
    LineChartGenerator,
  },
  props: {
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 100,
    },
    height: {
      type: Number,
      default: 300,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      chartData: {
        labels: [
          "",
          "24 May",
          "25 May",
          "26 May",
          "27 May",
          "28 May",
          "29 May",
          "30 May",
          "1 JUN",
        ],
        datasets: [
          {
            label: "",
            fill: false,
            borderColor: "#D18911",
            borderWidth: 4,
            data: [0, 40, 39, 10, 40, 30, 20, 15],
            lineTension: 0, //graph radius none
            pointHoverBackgroundColor: "rgba(255,255,255,0.6)",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointBorderWidth: 0,
          },
        ],
      },
      chartData1: {
        labels: [
          "",
          "24 May",
          "25 May",
          "26 May",
          "27 May",
          "28 May",
          "29 May",
          "30 May",
          "1 JUN",
        ],
        datasets: [
          {
            label: "",
            fill: false,
            borderColor: "#D18911",
            borderWidth: 4,
            data: [0, 20, 30, 25, 30, 30, 30, 15],
            lineTension: 0, //graph radius none
            pointHoverBackgroundColor: "rgba(255,255,255,0.6)",
            pointRadius: 0,
            pointHoverRadius: 0,
            pointBorderWidth: 0,
          },
        ],
      },
      chartOptions: {
        plugins: {
          legend: {
            position: "top",
            labels: {
              boxWidth: 50,
              usePointStyle: true,
              pointStyle: "line",
            },
          },
        },
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          x: {
            grid: {
              display: false,
            },
          },
          y: {
            grid: {
              display: true,
              borderColor: "transparent",
            },
          },
        },
      },
    };
  },
};
</script>

<style scoped>
h1 {
  font-family: "DM Sans";
  font-size: 18px;
  font-weight: 700;
}
.count {
  font-family: "DM Sans";
  font-size: 34px;
  font-weight: 700;
  color: #d18911;
}
</style>